import * as ActionTypes from './ActionType';

export const AssetSeries = (state = {
        isLoading: false,
        errMess: null,
        data: null
    }, action) => {
    switch(action.type){
        case ActionTypes.ADD_SERIES:
            return {...state, isLoading: false, errMess: null, data: action.payload}
        case ActionTypes.SERIES_LOADING:
            return {...state, isLoading: true, errMess: null, data:null}
        case ActionTypes.SERIES_FAILED:
            return {...state, isLoading: false, errMess: action.payload, data:null}
        case ActionTypes.SERIES_RESET:
            return {...state, isLoading: false, errMess: null, data:null}
        default:
            return state;
    }
}
